// @ts-nocheck

export function fmtInt(n) {
  return Number(n || 0).toLocaleString();
}

export function fmtDmg(n) {
  const v = Number(n || 0);
  if (v >= 1000) return `${Math.round(v).toLocaleString()}`;
  return v.toLocaleString(undefined, { maximumFractionDigits: 0 });
}

export function fmtPlaytime(secs) {
  const s = Math.max(0, Math.floor(Number(secs) || 0));
  if (s <= 0) return "0m";
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (h > 0) return m > 0 ? `${h}h ${m}m` : `${h}h`;
  if (m > 0) return `${m}m`;
  return "<1m";
}

function easeOutCubic(t) {
  return 1 - Math.pow(1 - t, 3);
}

export function runStatCountUp(el, spec, durationMs) {
  const start = performance.now();
  const tick = (now) => {
    if (!el.isConnected) return;
    const t = Math.min(1, (now - start) / durationMs);
    const e = easeOutCubic(t);
    switch (spec.kind) {
      case "int":
        el.textContent = fmtInt(Math.round(spec.to * e));
        break;
      case "dmg":
        el.textContent = fmtDmg(spec.to * e);
        break;
      case "playtime":
        el.textContent = fmtPlaytime(Math.round(spec.to * e));
        break;
      case "ratio":
        el.textContent = `${fmtInt(Math.round(spec.a * e))} / ${fmtInt(spec.b)}`;
        break;
    }
    if (t < 1) requestAnimationFrame(tick);
  };
  if (spec.kind === "playtime") el.textContent = "0m";
  else if (spec.kind === "ratio") el.textContent = `0 / ${fmtInt(spec.b)}`;
  else if (spec.kind === "dmg") el.textContent = "0";
  else el.textContent = "0";
  requestAnimationFrame(tick);
}

export function statCountCell(label, spec, durationMs) {
  const el = document.createElement("div");
  el.className = "profile-stat";
  const valueEl = document.createElement("div");
  valueEl.className = "profile-stat-value";
  const labelEl = document.createElement("div");
  labelEl.className = "profile-stat-label";
  labelEl.textContent = label;
  el.appendChild(valueEl);
  el.appendChild(labelEl);
  if (typeof spec === "string") {
    valueEl.textContent = spec;
    return el;
  }
  runStatCountUp(valueEl, spec, durationMs);
  return el;
}
